export default {
    persona: {
        apellido: '',
        nombre: '',
        tipo_documento: '',
        nro_documento: '',
    },
    domicilio: '',
    email: '',
    telefono: '',
    menor: 0,
    menores: '',
    defensoria: '',
    detenido: 0,
    dependencia: '',
    fecha_detencion: '',
    hora_detencion: '',
    fecha_vencimiento: '',
    hora_vencimiento: '',
    particular: []
}